import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5d626f3c = () => interopDefault(import('../app/pages/family/index.vue' /* webpackChunkName: "pages/family/index" */))
const _242c197e = () => interopDefault(import('../app/pages/headers.vue' /* webpackChunkName: "pages/headers" */))
const _51f87664 = () => interopDefault(import('../app/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _a46a9d3a = () => interopDefault(import('../app/pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _3fe53d2e = () => interopDefault(import('../app/pages/offline-devices.vue' /* webpackChunkName: "pages/offline-devices" */))
const _0ba630f8 = () => interopDefault(import('../app/pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _367c4f67 = () => interopDefault(import('../app/pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _2dbcbc8d = () => interopDefault(import('../app/pages/purchases.vue' /* webpackChunkName: "pages/purchases" */))
const _1f804cf3 = () => interopDefault(import('../app/pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _763cac9e = () => interopDefault(import('../app/pages/redeem.vue' /* webpackChunkName: "pages/redeem" */))
const _60d057f5 = () => interopDefault(import('../app/pages/subscription/index.vue' /* webpackChunkName: "pages/subscription/index" */))
const _451abe02 = () => interopDefault(import('../app/pages/your-data.vue' /* webpackChunkName: "pages/your-data" */))
const _7f29e926 = () => interopDefault(import('../app/pages/profile/change-password.vue' /* webpackChunkName: "pages/profile/change-password" */))
const _745669f6 = () => interopDefault(import('../app/pages/profile/edit.vue' /* webpackChunkName: "pages/profile/edit" */))
const _0036e032 = () => interopDefault(import('../app/pages/subscription/cancel.vue' /* webpackChunkName: "pages/subscription/cancel" */))
const _266f695a = () => interopDefault(import('../app/pages/subscription/cancel-confirm.vue' /* webpackChunkName: "pages/subscription/cancel-confirm" */))
const _1485c574 = () => interopDefault(import('../app/pages/subscription/canceled.vue' /* webpackChunkName: "pages/subscription/canceled" */))
const _c31fced0 = () => interopDefault(import('../app/pages/subscription/downgrade.vue' /* webpackChunkName: "pages/subscription/downgrade" */))
const _50930e92 = () => interopDefault(import('../app/pages/subscription/edit.vue' /* webpackChunkName: "pages/subscription/edit" */))
const _8d58fc26 = () => interopDefault(import('../app/pages/subscription/edit-success.vue' /* webpackChunkName: "pages/subscription/edit-success" */))
const _1207ab85 = () => interopDefault(import('../app/pages/subscription/start.vue' /* webpackChunkName: "pages/subscription/start" */))
const _21ee4502 = () => interopDefault(import('../app/pages/subscription/upgrade.vue' /* webpackChunkName: "pages/subscription/upgrade" */))
const _7118266b = () => interopDefault(import('../app/pages/v1/health.vue' /* webpackChunkName: "pages/v1/health" */))
const _bba1b5c0 = () => interopDefault(import('../app/pages/family/accept-invite/_validationSessionId.vue' /* webpackChunkName: "pages/family/accept-invite/_validationSessionId" */))
const _ef5e5966 = () => interopDefault(import('../app/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/family",
    component: _5d626f3c,
    name: "family"
  }, {
    path: "/headers",
    component: _242c197e,
    name: "headers"
  }, {
    path: "/login",
    component: _51f87664,
    name: "login"
  }, {
    path: "/notifications",
    component: _a46a9d3a,
    name: "notifications"
  }, {
    path: "/offline-devices",
    component: _3fe53d2e,
    name: "offline-devices"
  }, {
    path: "/payment",
    component: _0ba630f8,
    name: "payment"
  }, {
    path: "/profile",
    component: _367c4f67,
    name: "profile"
  }, {
    path: "/purchases",
    component: _2dbcbc8d,
    name: "purchases"
  }, {
    path: "/receipt",
    component: _1f804cf3,
    name: "receipt"
  }, {
    path: "/redeem",
    component: _763cac9e,
    name: "redeem"
  }, {
    path: "/subscription",
    component: _60d057f5,
    name: "subscription"
  }, {
    path: "/your-data",
    component: _451abe02,
    name: "your-data"
  }, {
    path: "/profile/change-password",
    component: _7f29e926,
    name: "profile-change-password"
  }, {
    path: "/profile/edit",
    component: _745669f6,
    name: "profile-edit"
  }, {
    path: "/subscription/cancel",
    component: _0036e032,
    name: "subscription-cancel"
  }, {
    path: "/subscription/cancel-confirm",
    component: _266f695a,
    name: "subscription-cancel-confirm"
  }, {
    path: "/subscription/canceled",
    component: _1485c574,
    name: "subscription-canceled"
  }, {
    path: "/subscription/downgrade",
    component: _c31fced0,
    name: "subscription-downgrade"
  }, {
    path: "/subscription/edit",
    component: _50930e92,
    name: "subscription-edit"
  }, {
    path: "/subscription/edit-success",
    component: _8d58fc26,
    name: "subscription-edit-success"
  }, {
    path: "/subscription/start",
    component: _1207ab85,
    name: "subscription-start"
  }, {
    path: "/subscription/upgrade",
    component: _21ee4502,
    name: "subscription-upgrade"
  }, {
    path: "/v1/health",
    component: _7118266b,
    name: "v1-health"
  }, {
    path: "/family/accept-invite/:validationSessionId?",
    component: _bba1b5c0,
    name: "family-accept-invite-validationSessionId"
  }, {
    path: "/",
    component: _ef5e5966,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
